<template>
  <div class="blog__link">
    <a :href="'/'+ item.type + '/' + item.slug" class="blog__link-href">
      <img :src="`${$baseURL}assets/${item.intro_img.id}`" :alt="item.intro_img.title" class="blog__link-image" />
    </a>
    <div class="blog__link-text">
      <a :href="'/'+ item.type + '/' + item.slug">
        <h3>{{ item.heading }}</h3>
      </a>
      <p>
        <span v-for="(tag, index) in item.tags" :key="index">
          #{{ tag }}
          <span v-if="index + 1 < item.tags.length"></span>
        </span>
      </p>
      <p>{{ item.intro }}</p>
      <p>{{ item.date | moment }}</p>
    </div>
  </div>
</template>

<script>
import moment from "moment";
moment.locale("cs");
export default {
  props: ["item"],
  data() {
    return {};
  },
  filters: {
    moment: function (date) {
      return moment(date).format("MMMM YYYY");
    },
  },
};
</script>
<style scoped>
.blog__link {
  grid-column: span 1;
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  gap: 0 48px;
  align-items: center;
}

.blog__link-href {
  grid-column: span 2;
}

.blog__link-image {
  height: 280px;
  width: 100%;
  object-fit: cover;
  border-radius: 48px;
}

.blog__link-text {
  text-align: left;
  grid-column: span 3;
}

@media only screen and (max-width: 1200px) {
  .blog__link {
    grid-column: span 2;
  }
}

@media only screen and (max-width: 400px) {
  .blog__link-href,
  .blog__link-text {
    grid-column: span 5;
    text-align: center;
  }
  .blog__link {
    text-align: center;
  }
}
</style>
